import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Button, Space, Typography } from 'antd';
import { 
  HomeOutlined, 
  ArrowLeftOutlined, 
  FrownOutlined 
} from '@ant-design/icons';
import './NotFound.scss';

const { Paragraph } = Typography;

/**
 * NotFound Component
 * ------------------
 * Features:
 * - Smooth entrance animations
 * - Floating background elements
 * - Animated gradient effects
 * - Interactive hover states
 * - Responsive design
 * - Consistent with Users module color scheme
 */
const NotFound = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleBack = () => {
    navigate(-1); // Navigate to the previous page in browser history
  };

  const handleGoHome = () => {
    navigate('/'); // Navigate to the home page
  };

  return (
    <div className={`not-found-container ${isVisible ? 'visible' : ''}`}>
      {/* Floating background elements */}
      <div className="floating-elements">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
        <div className="floating-circle circle-4"></div>
      </div>

      <div className="result-wrapper">
        <Result
          status="404"
          title={
            <span className="animated-title">
              <span className="digit">4</span>
              <span className="digit">0</span>
              <span className="digit">4</span>
            </span>
          }
          subTitle={
            <Space direction="vertical" size="small" align="center" className="subtitle-wrapper">
              <Paragraph strong className="main-message">
                Sorry, the page you visited does not exist.
              </Paragraph>
              <Paragraph type="secondary" className="sub-message">
                The page you are looking for might have been removed, renamed, 
                or is temporarily unavailable.
              </Paragraph>
            </Space>
          }
          icon={
            <div className="icon-wrapper">
              <FrownOutlined className="animated-icon" />
              <div className="icon-glow"></div>
            </div>
          }
          extra={
            <Space size="middle" wrap className="button-group">
              <Button
                type="primary"
                icon={<HomeOutlined />}
                size="large"
                onClick={handleGoHome}
                className="primary-action-btn"
              >
                Back Home
              </Button>
              <Button
                icon={<ArrowLeftOutlined />}
                size="large"
                onClick={handleBack}
                className="secondary-action-btn"
              >
                Go Back
              </Button>
            </Space>
          }
        />
      </div>
    </div>
  );
};

export default NotFound; 